import { createSlice } from '@reduxjs/toolkit'

import { getDevicePolicyPricesAPI, postNewPriceAPI } from '@/api/devicePolicyAPI'
import { getFilteredList, getRegexSafeString } from '@/util/misc'

export const NAME = 'device-policy'

const LIST_ROW_RENDER_STEP = 50

export const createDevicePolicy = ({ id, name, customerName }: any) => ({
  id,
  name,
  customerName,
})

export const createDevicePolicyPrice = ({
  id,
  type,
  model,
  customerId,
  customerName,
  policyId,
  policyName,
  price,
  currency,
}: any) => ({
  id,
  type,
  model,
  customerId,
  customerName,
  policyId,
  policyName,
  price,
  currency,
})
// @ts-ignore
export const fetchDevicePolicyPrices = () => async (dispatch, getState) => {
  const isPending = getIsPending(getState())

  if (isPending) return

  dispatch(pending())

  try {
    const result = await getDevicePolicyPricesAPI()

    dispatch(success(result))
  } catch (error) {
    dispatch(failure('Could not load your device policies'))
  }
}
// @ts-ignore
export const updatePrice = (id, price) => async dispatch => {
  try {
    const newPrice = await postNewPriceAPI({ id, price })

    dispatch(replacePrice(newPrice))
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error)
  }
}

const initialState = {
  pending: false,
  isDataLoaded: false,
  error: undefined,
  prices: [],
  devicePolicies: [],
  listRenderLimit: 70,
  textFilter: '',
  dpFilter: 0,
}

const { actions, reducer } = createSlice({
  name: NAME,
  initialState,
  reducers: {
    pending: state => {
      state.error = undefined
      state.pending = true
    },
    success: (state, { payload }) => {
      const { prices, devicePolicies } = payload
      state.pending = false
      state.isDataLoaded = true
      state.prices = prices
      state.devicePolicies = devicePolicies
      state.listRenderLimit = initialState.listRenderLimit // maybe not!?
    },
    failure: (state, { payload: error }) => {
      state.pending = false
      state.isDataLoaded = true
      state.error = error
    },
    increaseListRenderLimit: state => {
      state.listRenderLimit = state.listRenderLimit + LIST_ROW_RENDER_STEP
    },
    replacePrice: (state, { payload: newPrice }) => {
      // @ts-ignore
      state.prices = state.prices.map(price => (price.id === newPrice.id ? newPrice : price))
    },
    setTextFilter: (state, { payload: textFilter }) => {
      state.textFilter = textFilter
      state.listRenderLimit = initialState.listRenderLimit
    },
    setDpFilter: (state, { payload: dpFilter }) => {
      state.dpFilter = dpFilter
      state.listRenderLimit = initialState.listRenderLimit
    },
    reset: () => ({
      ...initialState,
    }),
  },
})

export const {
  pending,
  success,
  failure,
  reset,
  increaseListRenderLimit,
  replacePrice,
  setTextFilter,
  setDpFilter,
} = actions
export default reducer
// @ts-ignore
const getState = state => state[NAME]
// @ts-ignore
export const getIsPending = state => getState(state).pending
// @ts-ignore
export const getError = state => getState(state).error
// @ts-ignore
export const getIsDataLoaded = state => getState(state).isDataLoaded
// @ts-ignore
export const getDevicePolicies = state => getState(state).devicePolicies
// @ts-ignore
export const getPrices = state => getState(state).prices
// @ts-ignore
export const getFilteredPrices = state => getFilteredList(state, getPrices, textFilter, dpFilter)

// @ts-ignore
export const getNumberOfPrices = state => getFilteredPrices(state).length
// @ts-ignore
export const getVisiblePrices = state =>
  getFilteredPrices(state).slice(0, getListRenderLimit(state))

// @ts-ignore
export const getListRenderLimit = state => getState(state).listRenderLimit
// @ts-ignore
export const getPriceListExceedsLimit = state =>
  getListRenderLimit(state) < getNumberOfPrices(state)

// @ts-ignore
export const getTextFilter = state => getState(state).textFilter
// @ts-ignore
export const getDpFilter = state => getState(state).dpFilter
// @ts-ignore
const textFilter = (state, prices) => {
  const textFilter = getTextFilter(state)
  if (!textFilter) return prices

  const keyWords = getRegexSafeString(textFilter).split(' ')
  // @ts-ignore
  return prices.filter(price =>
    // @ts-ignore
    keyWords.every(keyWord => {
      const regExp = new RegExp(keyWord, 'i')
      return `${price.customerName} ${price.policyName} ${price.model}`.match(regExp)
    })
  )
}
// @ts-ignore
const dpFilter = (state, prices) => {
  const dpFilter = getDpFilter(state)
  // @ts-ignore
  return dpFilter ? prices.filter(price => price.policyId === dpFilter) : prices
}
